import * as React from "react";
import { BubbleStepper } from "./BubbleStepper";
// import { Icon, Steps } from "rsuite"; //TODO-SGA : Remove rsuite

export interface IDrupalStepperProps {
  stepNumber: number;
  steps?: number;
}

export const DrupalStepper: React.FunctionComponent<IDrupalStepperProps> = ({ stepNumber, steps }) => {
  return <BubbleStepper currentStep={stepNumber + 1} steps={steps ?? 3} />;
};
